import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const LeadCompanyRecord = Record({
  id: 0,
  name: '',
});

export default class LeadCompany extends LeadCompanyRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new LeadCompany(hydrated);
  }
}
